import React from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './CustomToastContainer.module.scss';

const CustomToastContainer: React.FC = () => {
  const location = useLocation();

  const getToastContainerClassName = () => {
    if (location.pathname === '/signin' || location.pathname.startsWith('/registration')) {
      return styles.fullScreenToastContainer;
    } else {
      return styles.appToastContainer;
    }
  };

  return <ToastContainer className={`${styles.baseToastContainer} ${getToastContainerClassName()}`} />;
};

export default CustomToastContainer;